import { ReactNode } from "react";
import { cls } from "../format";

interface CardProps {
  children: ReactNode;
  className?: string;
  tone?: "good" | "warn" | "bad" | "info" | "default";
}

export const Card = ({ children, className, tone = "default" }: CardProps) => {
  return (
    <div className={cls("card", tone !== "default" && `tone-${tone}`, className)}>
      {children}
    </div>
  );
};
